import React from 'react';
import dayjs, { Dayjs } from 'dayjs';

interface Props {
  displayDate: Dayjs;
  selected: (data: Dayjs) => void;
  disabled: (data: Dayjs) => void;
  generateDay: (
    i: number,
    selecte: boolean | void,
    disable: boolean | void,
  ) => React.JSX.Element;
}

const PopulateWeeks = ({
  displayDate,
  selected,
  disabled,
  generateDay,
}: Props) => {
  const weeks = [];
  let week = [];
  const daysInMonth = displayDate?.daysInMonth();
  const startOfMonth = dayjs(displayDate).set('date', 1);
  const offset = startOfMonth.day();

  week = week.concat(
    Array.from({ length: offset }, (x, i) => (
      <div
        key={`empty-${i}`}
        className="d-flex justify-content-center date-picker-day"
      />
    )),
  );

  for (let i = 1; i <= daysInMonth; ++i) {
    const date = dayjs(displayDate).set('date', i);
    const selecte = selected(date);
    const disable = disabled(date);
    const day = generateDay(i, selecte, disable);
    week.push(day);
    if ((i + offset) % 7 === 0 || i === daysInMonth) {
      if (week.length < 7) {
        week = week.concat(
          Array.from({ length: 7 - week.length }, (x, i) => (
            <div
              key={`empty-${i}`}
              className="d-flex justify-content-center date-picker-day"
            />
          )),
        );
      }
      weeks.push(
        <div
          className="d-flex flex-wrap justify-content-evenly gap-2"
          key={`weeks-${i}`}
        >
          {week}
        </div>,
      );
      week = [];
    }
  }
  return weeks;
};

export default PopulateWeeks;
